export default __webpack_public_path__ + "static/media/chevronWhite.3d062c99.svg";